import { Component, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { Shared, UserService } from '@rubii/frontend-common';

@Component({
  selector: 'app-scope3',
  templateUrl: './scope3.component.html',
  styleUrls: ['./scope3.component.scss']
})
export class Scope3Component extends BaseDatasourceComponent implements OnInit {

  scope3Email = '';

  constructor(private user: UserService) {
    super();
  }

  ngOnInit() {
    this.scope3Email = 'report+scope3+' + this.user.user.tenant.token + '+' + this.user.user.id + '@rubii.io';
  }

}
